import { merchantApi } from '@/config/axios'

/** E4+ 开票 / 退费 / 提成 / 所政 */

export const FirmOfficeApi = {
  invoicePage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeInvoiceVO[]; total: number }>({
      url: '/firm-api/practice/invoice/page',
      params
    }),
  invoiceCreate: (data: {
    caseId: number
    invoiceNo: string
    amount: number
    invoiceDate: string
    title?: string
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/invoice/create', data }),
  invoiceIssue: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/invoice/issue', params: { id } }),
  invoiceVoid: (data: { id: number; voidReason?: string }) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/invoice/void', data }),

  refundPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeRefundVO[]; total: number }>({
      url: '/firm-api/practice/refund/page',
      params
    }),
  refundCreate: (data: {
    caseId: number
    amount: number
    reason: string
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/refund/create', data }),
  refundSubmit: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/refund/submit', params: { id } }),
  refundApprove: (data: { id: number; approved: boolean; comment?: string }) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/refund/approve', data }),
  refundConfirm: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/refund/confirm-refund', params: { id } }),

  commissionRulePage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeCommissionRuleVO[]; total: number }>({
      url: '/firm-api/practice/commission/rule/page',
      params
    }),
  commissionRuleCreate: (data: {
    name: string
    baseType: string
    rate: number
    lawyerId: number
    enabled?: boolean
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/commission/rule/create', data }),
  commissionRuleDelete: (id: number) =>
    merchantApi.delete<boolean>({ url: '/firm-api/practice/commission/rule/delete', params: { id } }),
  commissionEntryPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeCommissionEntryVO[]; total: number }>({
      url: '/firm-api/practice/commission/entry/page',
      params
    }),
  commissionGenerate: (data: { ruleId: number; sourceType: string; sourceId: number }) =>
    merchantApi.post<number>({ url: '/firm-api/practice/commission/entry/generate', data }),
  commissionEntryVoid: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/commission/entry/void', params: { id } }),

  noticePage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeNoticeVO[]; total: number }>({
      url: '/firm-api/practice/admin/notice/page',
      params
    }),
  noticeCreate: (data: {
    title: string
    content: string
    scopeType: string
    scopeId?: number
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/admin/notice/create', data }),
  noticePublish: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/admin/notice/publish', params: { id } }),
  noticeArchive: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/admin/notice/archive', params: { id } }),

  docCategoryTree: () =>
    merchantApi.get<PracticeDocCategoryVO[]>({ url: '/firm-api/practice/admin/doc/category/tree' }),
  docCategoryCreate: (data: { name: string; parentId?: number; sort?: number }) =>
    merchantApi.post<number>({ url: '/firm-api/practice/admin/doc/category/create', data }),
  docPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeDocVO[]; total: number }>({
      url: '/firm-api/practice/admin/doc/page',
      params
    }),
  docCreate: (data: {
    categoryId: number
    title: string
    scopeType: string
    fileUrl: string
    fileName?: string
    description?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/admin/doc/create', data }),
  docDelete: (id: number) =>
    merchantApi.delete<boolean>({ url: '/firm-api/practice/admin/doc/delete', params: { id } }),

  calendarEvents: (params: { from: string; to: string; lawyerId?: number }) =>
    merchantApi.get<PracticeCalendarEventVO[]>({
      url: '/firm-api/practice/admin/calendar/events',
      params
    }),
  calendarCreate: (data: {
    lawyerId: number
    eventType: string
    title: string
    startTime: string
    endTime: string
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/admin/calendar/create', data }),
  calendarDelete: (id: number) =>
    merchantApi.delete<boolean>({ url: '/firm-api/practice/admin/calendar/delete', params: { id } }),

  sealPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeSealVO[]; total: number }>({
      url: '/firm-api/practice/admin/seal/page',
      params
    }),
  sealCreate: (data: {
    reason: string
    fileName: string
    copies: number
    caseId?: number
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/admin/seal/create', data }),
  sealSubmit: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/admin/seal/submit', params: { id } }),
  sealApprove: (data: { id: number; approved: boolean; remark?: string }) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/admin/seal/approve', data }),
  sealConfirmUse: (data: { id: number; scanFileUrl?: string; remark?: string }) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/admin/seal/confirm-use', data }),

  retainerPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: PracticeRetainerVO[]; total: number }>({
      url: '/firm-api/practice/retainer/page',
      params
    }),
  retainerCreate: (data: {
    customerId: number
    title: string
    annualFee: number
    startDate: string
    endDate: string
    caseId?: number
    leadLawyerId?: number
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/retainer/create', data }),
  retainerTerminate: (id: number) =>
    merchantApi.put<boolean>({ url: '/firm-api/practice/retainer/terminate', params: { id } }),
  retainerServiceLogList: (retainerId: number) =>
    merchantApi.get<PracticeRetainerLogVO[]>({
      url: '/firm-api/practice/retainer/service-log/list',
      params: { retainerId }
    }),
  retainerServiceLogCreate: (data: {
    retainerId: number
    serviceDate: string
    content: string
    hours?: number
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/practice/retainer/service-log/create', data })
}

export interface PracticeInvoiceVO {
  id?: number
  caseId: number
  caseTitle?: string
  firmCaseNo?: string
  invoiceNo: string
  title?: string
  amount: number
  invoiceDate: string
  status?: string
  createTime?: string
}

export interface PracticeRefundVO {
  id?: number
  caseId: number
  caseTitle?: string
  firmCaseNo?: string
  amount: number
  reason: string
  status?: string
  createTime?: string
}

export interface PracticeCommissionRuleVO {
  id?: number
  name: string
  baseType: string
  rate: number
  lawyerId?: number
  lawyerName?: string
  enabled?: boolean
  createTime?: string
}

export interface PracticeCommissionEntryVO {
  id?: number
  ruleId: number
  ruleName?: string
  caseId?: number
  caseTitle?: string
  firmCaseNo?: string
  lawyerName?: string
  sourceType: string
  sourceId: number
  baseAmount?: number
  rate?: number
  amount: number
  status?: string
  createTime?: string
}

export interface PracticeNoticeVO {
  id?: number
  title: string
  content: string
  scopeType: string
  status?: string
  publishTime?: string
  createTime?: string
}

export interface PracticeDocCategoryVO {
  id: number
  name: string
  parentId?: number
  children?: PracticeDocCategoryVO[]
}

export interface PracticeDocVO {
  id?: number
  categoryId: number
  categoryName?: string
  title: string
  fileUrl?: string
  fileName?: string
  versionNo?: number
  createTime?: string
}

export interface PracticeCalendarEventVO {
  id?: number
  eventType: string
  editable?: boolean
  lawyerId?: number
  lawyerName?: string
  caseId?: number
  firmCaseNo?: string
  title: string
  startTime: string
  endTime: string
  location?: string
  conflictHint?: string
}

export interface PracticeSealVO {
  id?: number
  reason: string
  fileName: string
  copies: number
  caseId?: number
  firmCaseNo?: string
  caseTitle?: string
  status?: string
  createTime?: string
}

export interface PracticeRetainerVO {
  id?: number
  customerId: number
  customerName?: string
  caseId?: number
  caseTitle?: string
  firmCaseNo?: string
  title: string
  annualFee: number
  startDate: string
  endDate: string
  status?: string
  leadLawyerId?: number
  remark?: string
  createTime?: string
}

export interface PracticeRetainerLogVO {
  id?: number
  retainerId: number
  serviceDate: string
  content: string
  hours?: number
  remark?: string
  createTime?: string
}
